/** * * Asynchronously loads the component for
Feedbacks
* */ import { lazyLoad } from "utils/loadable";
export const Feedbacks = lazyLoad(
  () => import("./index"),
  (module) => module.Feedbacks
);